import { render, staticRenderFns } from "./SideBarComponent.vue?vue&type=template&id=5cf97b3b&"
import script from "./SideBarComponent.vue?vue&type=script&lang=js&"
export * from "./SideBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./SideBarComponent.vue?vue&type=style&index=0&id=5cf97b3b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports